import * as types from '../actions/actionTypes';

const defaultState = {
  userInfo: {
    loading: false,
    isError: false,
    data: {},
  },
  teams: {
    loading: false,
    data: [],
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCH_PUBLIC_USER_INFO:
      return {
        ...state,
        userInfo: { loading: true, data: {}, isError: false },
      };
    case types.FETCH_PUBLIC_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: { loading: false, data: action.payload, isError: false },
      };
    case types.FETCH_PUBLIC_USER_INFO_FAILED:
      return {
        ...state,
        userInfo: { loading: false, data: {}, isError: true },
      };
    case types.FETCH_PUBLIC_USER_TEAMS:
      return { ...state, teams: { loading: true, data: [] } };
    case types.FETCH_PUBLIC_USER_TEAMS_SUCCESS:
      return { ...state, teams: { loading: false, data: action.payload } };
    case types.FETCH_PUBLIC_USER_TEAMS_FAILED:
      return { ...state, teams: { loading: false, data: [] } };
    default:
      return state;
  }
};
